const getFlowUsagesRequestState = state => state.automationTab.flowUsages.requestState;
export default getFlowUsagesRequestState;